export default __webpack_public_path__ + "static/media/map.da614ec2.png";